;(() => {
  function initFaq() {
    const questions = document.querySelectorAll(".faq__question")

    for (const question of questions) {
      question.addEventListener("click", () => {
        question.closest(".faq__item").classList.toggle("faq__item--active")
      })
    }
  }

  window.addEventListener("DOMContentLoaded", () => {
    initFaq()
  })
})()
